export default "https://shopfront-cdn.tekoapis.com/_next/static/images/sgc_img_18+-20719fc2d35a93e724582b34140f32a0.svg";